/* eslint-disable*/
import React from 'react';
import PropTypes from 'prop-types';
import { DtpContentContainer } from 'dtp-react-components';
import { Button } from '../../components/index';
import InfoPagamento from './templates/InfoPagamento';
import InfoPagamentoRGPS from './templates/infoPagamentoRGPS';
import InfoPagamentoGRU from './templates/infoPagamentoGRU';
import { Mensagem } from './templates/Mensagem';
import NovaMensagem from './templates/NovaMensagem';
import {
  doGet,
} from '../../utils/requests';
import './templates/impressaoDetalheControlePagto.css';

const classeParaInibirImpressao = "esconder-print";
const classeCabecalho = 'dtp-header';
const classeLogoUsuario = 'user-target';
const classeBotaoVoltar = 'dtp-btn';
const PAGAMENTO_GRU_FORA_COMPREV = 'Pagamento efetuado fora do COMPREV (GPS ou GRU cobrança)';

class DetalhePagamento extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    infoPagamento: {
      idControlePagamento: null,
      nomeEntidadePagadora: '',
      nomeEntidadeRecebedora: '',
      codigoBanco: '',
      nomeBanco: '',
      numeroAgencia: '',
      dvAgencia: '',
      numeroContaCorrente: '',
      dvContaCorrente: '',
      cnpj: '',
      mes: '',
      ano: '',
      valorCompensacao: '',
      dataVencimento: '',
      dataPagamentoAtraso: '',
      valorMulta: '',
      valorJuros: '',
      mensagens: [],
      estado: null,
      codigoParticipanteLogado: null,
      indicadorAtraso: null,
      novasMensagensPossiveis: [],
      grusTO: [],
      valorCarregado: null,
      dataPrazo: null,
    },
    papelUsuarioLogado: null,
  })
  
  componentDidMount() {
    this.montaFormulario();
    this.definePapelFiltro();

    const header = document.getElementsByClassName(classeCabecalho)[0];
    const logoUsuario = document.getElementsByClassName(classeLogoUsuario)[0];
    const botaoVoltar = document.getElementsByClassName(classeBotaoVoltar)[0];
    
    header.classList.add(classeParaInibirImpressao);
    logoUsuario.classList.add(classeParaInibirImpressao);
    botaoVoltar.classList.add(classeParaInibirImpressao);
  }

  definePapelFiltro = () => {
    let retorno = '';
    const isAnalistaDcomp = this.props.auth.checkPermission(['gerenciar-negocio-dcomp']);
    const isRpps = this.props.auth.checkPermission(['requerer-compensacao-rpps', 'analisar-compensacao-rpps', 'consultar-compensacao-rpps']);
    const isAnalistaSprev = this.props.auth.checkPermission(['analisar-negocio-sprev']);
    const isAnalistaDtp = this.props.auth.checkPermission(['analisar-negocio-dtpv']);

    if (isAnalistaDcomp) {
      retorno = 'analista-rgps';
    }
    if (isRpps) {
      retorno = 'analista-rpps';
    }
    if (isAnalistaSprev) {
      retorno = 'analista-sprev';
    }
    if (isAnalistaDtp) {
      retorno = 'analista-dtp';
    }

    this.setState({
      papelUsuarioLogado: retorno,
    });
  }

  print(){
    window.print();
  }

  componentWillUnmount(){
    const header = document.getElementsByClassName(classeCabecalho)[0];
    const logoUsuario = document.getElementsByClassName(classeLogoUsuario)[0];
    const botaoVoltar = document.getElementsByClassName(classeBotaoVoltar)[0];

    header.classList.remove(classeParaInibirImpressao);
    logoUsuario.classList.remove(classeParaInibirImpressao);
    botaoVoltar.classList.add(classeParaInibirImpressao);
  }

  montaFormulario = () => {
    if (this.props.match.params.idControlePagamento) {
      this.setState(this.buscaPagamento(this.props.match.params.idControlePagamento));
    }  
  }

  buscaPagamento = (chave) => {
    const url = `controle-pagamentos/${chave}/${this.props.match.params.tipoControle}`;
    doGet(url, this.handleSuccess, this.handleError);
  }
  
  verificaIdGruNossoNumero= (lista) => {
    if (lista && lista.length > 0 ) {
      const listaMensagens = lista.map((mensagem) => {
        const mensagemIndexado = mensagem;
        mensagemIndexado.idGruNossoNumero = mensagem.idGruNossoNumero !== '0' ? mensagem.idGruNossoNumero: PAGAMENTO_GRU_FORA_COMPREV;
        return mensagemIndexado;
      });
      this.setState({
        ...this.state,
        infoPagamento: {
            mensagens: listaMensagens,
        },
      });
    }
  }

  handleSuccess = (response) => {
    if (response.data) {
      this.setState({
        infoPagamento: 
        { ...this.state.infoPagamento, ...response.data } 
      })
    }
  }

  handleError = (error) => {
    let mensagemPrimaria = 'Não foi possível consultar o pagamento.';
    let mensagemSecundaria = 'Contate o administrador do sistema.';
    if (error) {
      if (error.status) {
        if (error.status === 404) {
          mensagemPrimaria = 'Pagamento não encontrado para a chave informado.';
          mensagemSecundaria = 'Informe um pagamento válido.';
        }
      }
    }
    this.setState({
      showNoContent: true,
      noContentPrimaryMessage: mensagemPrimaria,
      noContentSecondaryMessage: mensagemSecundaria,
    });
  };

  obterUltimoValorParcial = () => {
    let ultimoValorParcial = null;
    this.state.infoPagamento.mensagens.filter((item)=>(item.valorParcial !== null && item.valorParcial > 0)).map((item) =>(ultimoValorParcial = item.valorParcial));
    return ultimoValorParcial;
  }

  validaExibicaoDoChatMensagens = () => {
    return this.state.infoPagamento.mensagens && this.state.infoPagamento.mensagens.length > 0;
  }
  
  renderDetalheComGRU = () => (
    <React.Fragment>
        <InfoPagamentoRGPS estadoFormulario={this.state} />
        <InfoPagamentoGRU estadoFormulario={this.state} />
    </React.Fragment>
  )

  renderDetalheComGRUEMensagens = (mensagemStyle) => (
    <React.Fragment>
        <InfoPagamentoRGPS estadoFormulario={this.state} />
        <InfoPagamentoGRU estadoFormulario={this.state} />
        <React.Fragment>
          {this.validaExibicaoDoChatMensagens() &&
            this.ordernarMensagens().map(msg => (
            <Mensagem
              mensagem={msg}
              valorCompensacao={this.state.infoPagamento.valorCompensacao}
              controlePagamento={this.state.infoPagamento}
            />))
          }
          {this.state.infoPagamento.mensagens.length === 0 &&
            <div style={mensagemStyle}>
              Não há mensagens entre os participantes deste pagamento.
            </div>
          }
          {this.state.infoPagamento.idControlePagamento &&
            <NovaMensagem
              infoPagamento={this.state.infoPagamento}
              acaoBuscarPagamento={this.buscaPagamento}
              estadoFormulario={this.state}
              handleChange={this.handleChange}
              valorParcial={this.obterUltimoValorParcial()}
              tipoControle={this.props.match.params.tipoControle}
            /> 
          }
          {this.state.infoPagamento.estado === 2 && 
            <div style={{...mensagemStyle, padding: this.state.infoPagamento.mensagens.length === 0 ? '12px 0px 25px' : '20px 0px 30px'}}>
              Não é possível apresentar defesa enquanto houver GRU em processamento. O processamento leva até 10 dias, após a data de vencimento da GRU.
                Aguardar o retorno para o estado "Não Pago" para apresentar defesa.
            </div>
          }
        </React.Fragment>
    </React.Fragment>
  )

  ordernarMensagens = () => {
    const { mensagens } = { ...this.state.infoPagamento };
    return mensagens.sort((a,b) => (a.idMensagem > b.idMensagem) ? 1 : ((b.idMensagem > a.idMensagem) ? -1 : 0));
  }
  
  renderDetalheComMensagens = (mensagemStyle) => (
    <React.Fragment>
        <InfoPagamento estadoFormulario={this.state} />
        {this.validaExibicaoDoChatMensagens() &&
          this.ordernarMensagens().map(msg => (
          <Mensagem
            mensagem={msg}
            valorCompensacao={this.state.infoPagamento.valorCompensacao}
            controlePagamento={this.state.infoPagamento}
          />))
        }
        {this.state.infoPagamento.mensagens.length === 0 &&
          <div style={mensagemStyle}>
            Não há mensagens entre os participantes deste pagamento.
          </div>
        }
        {this.state.infoPagamento.idControlePagamento &&
          <NovaMensagem
            infoPagamento={this.state.infoPagamento}
            acaoBuscarPagamento={this.buscaPagamento}
            estadoFormulario={this.state}
            handleChange={this.handleChange}
            valorParcial={this.obterUltimoValorParcial()}
            tipoControle={this.props.match.params.tipoControle}
          /> 
        }
        {this.state.infoPagamento.estado === 2 && 
          <div style={{...mensagemStyle, padding: this.state.infoPagamento.mensagens.length === 0 ? '12px 0px 25px' : '20px 0px 30px'}}>
            Não é possível apresentar defesa enquanto houver GRU em processamento. O processamento leva até 10 dias, após a data de vencimento da GRU.
              Aguardar o retorno para o estado "Não Pago" para apresentar defesa.
          </div>
        }
    </React.Fragment>
  )

  renderDetalhe = () => {
    const mensagemStyle = {
      margin: 'auto',
      padding: '20px 0px 30px',
      color: 'rgb(169 168 168)', 
      textAlign: 'center',
      fontSize:'17px',
      fontStyle: 'italic',
    }
    /*if (this.props.match.params.tipoControle === 'controle-pagamentos') {
      return (this.state.infoPagamento.tipoPagamento === 1) ? this.renderDetalheComGRU() : this.renderDetalheComMensagens();
    } else {
      return (this.state.infoPagamento.entidadeRecebedora === '01000') ? this.renderDetalheComGRUEMensagens() : this.renderDetalheComMensagens();
    }*/
    return (this.state.infoPagamento.tipoPagamento === 1) ? this.renderDetalheComGRUEMensagens(mensagemStyle) : this.renderDetalheComMensagens(mensagemStyle);
  };

  render() {
    let botaoAcaoVoltar;

    botaoAcaoVoltar = (
      <Button
        className="left"
        onClick={this.props.history.goBack}
        //onClick={this.print}
        title="Voltar"
        hint="Voltar para tela anterior"
      />
    );

    return (
      <div id='print-detalhamento-cp'>
        <DtpContentContainer>          
          {this.renderDetalhe()}
          { botaoAcaoVoltar }
        </DtpContentContainer>
      </div>
    );
  }
}
DetalhePagamento.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      acao: PropTypes.string,
      idControlePagamento: PropTypes.string,
      tipoControle: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    goBack: PropTypes.function,
  }).isRequired,
  readOnly: PropTypes.string,
};
DetalhePagamento.defaultProps = {
  match: null,
  readOnly: null,
};
export default DetalhePagamento;



// WEBPACK FOOTER //
// ./src/pages/controle-pagamento/DetalhePagamento.jsx